module.exports = {"id":"239271","name":"Giannis Anestis","rating":"71","photo":"./data/images/photos/4/239271.png","club":{"name":"AEK Athènes","logo":"./data/images/clubs/AEKAthenes.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GiannisAnestis0.json
// module id = 1590
// module chunks = 0